import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parsePhoneNumber, isValidPhoneNumber } from './phone-validator.utils';

/**
 * Custom Angular validator for phone number validation
 * @param control - The form control to validate
 * @returns ValidationErrors object if invalid, null if valid
 */
export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values (use required validator for that)
    }

    const phoneNumber = control.value.toString();
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

    if (!isValidPhoneNumber(parsedPhoneNumber)) {
      return {
        phoneNumber: {
          value: control.value,
          message: 'Invalid phone number format'
        }
      };
    }

    return null;
  };
}

/**
 * Async validator for phone number validation (if needed for server-side validation)
 * @param control - The form control to validate
 * @returns Promise<ValidationErrors | null>
 */
export function phoneNumberAsyncValidator(): ValidatorFn {
  return (control: AbstractControl): Promise<ValidationErrors | null> => {
    return new Promise((resolve) => {
      if (!control.value) {
        resolve(null);
        return;
      }

      const phoneNumber = control.value.toString();
      const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

      if (!isValidPhoneNumber(parsedPhoneNumber)) {
        resolve({
          phoneNumber: {
            value: control.value,
            message: 'Invalid phone number format'
          }
        });
      } else {
        resolve(null);
      }
    });
  };
}
